import React, {useRef, useState, useEffect} from 'react';
import {Button, Form} from 'react-bootstrap';
import * as AuthService from '../../services/auth';
import Select from 'react-select';
import {PfButton} from '@profabric/react-components';
import Switch from 'react-bootstrap-switch';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

export default function ModalSetBatch(props) {
  const [dropdownBatch, setDropdownBatch] = useState([]);
  const [error, setError] = useState('');
  const [state, setState] = useStateWithCallbackLazy({
    CAMPAIGN_COUNTRY: '',
    CAMPAIGN_QUOTA_UNIT: '',
    CAMPAIGN: '',
    CAMPAIGN_NAME: '',
    CAMPAIGN_IMG_B64: '',
    CAMPAIGN_ENVIRONMENT: 'PROD',
    CAMPAIGN_POINT: '',
    CAMPAIGN_QUOTA: '',
    CAMPAIGN_NEXT_BATCH: '',
    CAMPAIGN_NICK_NAME: '',
    IS_ACTIVE: 1
  });
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    console.log(props.item);
    setState({...props.item}, (state) => (downloadNextBatchWs(state)));
  }, []);

  const downloadNextBatchWs = async (state) => {
    try {
      const dropdowns = await AuthService.downloadBatch(
        state.CAMPAIGN_COUNTRY,
        state.CAMPAIGN
      );

      setDropdownBatch(dropdowns);
    } catch (error) {}
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const result = await props.onUpdate({CAMPAIGN : state.CAMPAIGN, CAMPAIGN_NEXT_BATCH : state.CAMPAIGN_NEXT_BATCH}, null);
      setLoading(false);
    } catch (error) {}
  };

  return (
    <div>
      <Form>
        <div className="row">
          <Form.Group className="mb-3 col-md-2">
            <Form.Control
              className="text-center"
              disabled
              value={state.CAMPAIGN}
              name="CAMPAIGN_NAME"
              type="text"
              placeholder="campaign name"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-2">
            <Form.Control
              className="text-center"
              disabled
              value={'->'}
              type="text"
              placeholder="campaign name"
            />
          </Form.Group>
          <Form.Group className="mb-6 col-md-8">
            <Select
              // defaultValue={dropdownBatch.find(
              //   (v) => v.select === 'SELECTED'
              // )}
              value={dropdownBatch.find(
                (v) => v.value === state.CAMPAIGN_NEXT_BATCH
              )}
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={'Select Next Batch'}
              options={dropdownBatch}
              id="countryid"
              onChange={(v) => {
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_NEXT_BATCH: v.length > 0 ? v.pop().value : ''
                }
                ));
              }}
            />
          </Form.Group>
        </div>
      </Form>
      <p className="text-danger">{error}</p>
      <PfButton
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleSubmit}
      >
        {'Save'}
      </PfButton>
    </div>
  );
}
